import Vulnerability from '../types/Vulnerability';

class VulnerabilitiesController {
  private readonly vulnerabilitiesList: Vulnerability[];

  constructor() {
    // Initialise class variables.
    this.vulnerabilitiesList = [];
  }

  /**
   * Extract and parse the payload.data into a list of type Vulnerability[].
   *
   * @param payload the API payload.
   * @returns the list of vulnerabilities from the payload.
   */
  private parsePayload(payload: Record<string, unknown>): Vulnerability[] {
    // Clear the list for the new payload.
    this.vulnerabilitiesList.length = 0;

    const data = payload.data as [];
    data.forEach((value) => {
      this.vulnerabilitiesList.push(Object.assign({}, value) as Vulnerability);
    });

    return this.vulnerabilitiesList;
  }

  /**
   * Calls the API to get the vulnerabilities payload.
   *
   * @param payloadUrl the API url.
   * @param onSuccess callback function if the fetch was successful.
   * @param onError callback function if the fetch failed.
   */
  public fetchPayload(
    payloadUrl: string,
    onSuccess: (vulnerabilitiesList: Vulnerability[]) => void,
    onError: (error: Error) => void
  ): void {
    fetch(payloadUrl)
      .then((response) => {
        if (response.ok) return response.json();
        throw new Error('Error loading vulnerabilities payload');
      })
      .then((payload) => onSuccess(this.parsePayload(payload)))
      .catch((error) => onError(error));
  }

  /**
   * Searches for a vulnerability in the vulnerabilitiesList by uuid.
   *
   * @param uuid the uuid to match.
   * @returns the vulernability if found, null otherwise.
   */
  public getVulnerabilityById(uuid: string | null): Vulnerability | null {
    if (this.vulnerabilitiesList.length === 0) return null;
    if (uuid === null) return null;

    return this.vulnerabilitiesList.find((vulnerability) => vulnerability.uuid === uuid) ?? null;
  }
}

export default VulnerabilitiesController;
